import React from 'react';
import PropTypes from 'prop-types';

const FieldError = ({message}) =>
	message && (
		<p style={{color: 'red', fontSize: 'x-small', marginLeft: '0.3em'}}>
			<b>{message}</b>
		</p>
	);

FieldError.propTypes = {
	message: PropTypes.string
};

FieldError.defaultProps = {
	message: ''
};

export default FieldError;
